(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ps-purchase-assist"] && !Shopify.designMode) return;
  try {
    class PsPurchaseAssist extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section');
    if (!this.section) return;
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    try {
      this.delivery = JSON.parse(this.querySelector('[data-delivery-tiers]')?.textContent || 'null');
    } catch (_) {
      this.delivery = null;
    }
    this.bar = this.querySelector('.ps-purchase-bar');
    this.abort = new AbortController();
    const options = { signal:this.abort.signal };
    if (this.bar) {
      document.body.append(this.bar);
      this.bar.querySelector('[data-buy]').addEventListener('click', () => {
        const button = this.sourceButton();
        if (!button || button.disabled || this.pending) return;
        button.click();
        this.schedule();
      }, options);
    }
    this.section.addEventListener('variant:selected', () => { this.pending = true; this.schedule(); }, options);
    this.section.addEventListener('variant:update', () => { this.pending = false; this.schedule(); }, options);
    this.section.addEventListener('change', () => this.schedule(), options);
    /* Quantity +/- and typing change the delivery shown (weight x quantity). */
    this.section.addEventListener('input', () => this.schedule(), options);
    this.section.addEventListener('click', () => this.schedule(), options);
    window.addEventListener('scroll', () => this.schedule(), {...options, passive:true});
    window.addEventListener('resize', () => this.schedule(), options);
    this.observer = new MutationObserver(() => this.schedule());
    const form = this.section.querySelector('.product-details product-form-component');
    const price = this.section.querySelector('.product-details product-price');
    if (form) this.observer.observe(form, {subtree:true,childList:true,attributes:true,characterData:true});
    if (price) this.observer.observe(price, {subtree:true,childList:true,characterData:true});
    this.querySelector('details')?.addEventListener('toggle', event => {
      if (!event.target.open) event.target.querySelector('video')?.pause();
    }, options);
    this.sync();
  }
  disconnectedCallback() {
    this.abort?.abort();
    this.observer?.disconnect();
    cancelAnimationFrame(this.frame);
    this.bar?.remove();
  }
  sourceButton() {
    return this.section.querySelector('.product-details product-form-component button[name="add"]');
  }
  schedule() {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
  }
  /* Delivery price for a weight: undefined below the lightest tier, null above the heaviest. */
  deliveryFor(grams) {
    const table = this.delivery;
    if (!table || !Array.isArray(table.tiers) || !(grams >= table.min)) return undefined;
    const tier = table.tiers.find((entry) => grams <= entry[0]);
    return tier ? tier[2] : null;
  }
  sync() {
    const button = this.sourceButton();
    const input = this.section.querySelector('.product-details product-form-component input[name="id"]');
    const variant = this.variants.find(item => String(item.id) === input?.value);
    if (this.bar) {
      const boundary = this.bar.hidden ? -8 : 24;
      const hidden = !button || window.innerWidth > 749 || button.getBoundingClientRect().bottom >= boundary;
      if (this.bar.hidden !== hidden) {
        this.bar.hidden = hidden;
        this.bar.inert = hidden;
        this.bar.setAttribute('aria-hidden', String(hidden));
      }
      const target = this.bar.querySelector('[data-buy]');
      target.disabled = !button || button.disabled || this.pending || !variant;
      target.textContent = this.pending ? this.dataset.wait : (button?.disabled ? (button.querySelector('.add-to-cart-text__content')?.textContent.trim() || this.dataset.add) : this.dataset.add);
      if (variant) this.bar.querySelector('[data-price]').textContent = variant.price;
      this.bar.querySelector('[data-option]').textContent = variant && variant.title !== 'Default Title' ? variant.title : '';
      const error = this.section.querySelector('.product-details [ref="addToCartTextError"]');
      const output = this.bar.querySelector('[data-error]');
      const errorText = error && !error.classList.contains('hidden') ? error.textContent.trim() : '';
      output.hidden = !errorText;
      output.textContent = errorText;
    }
    const link = this.querySelector('[data-inquiry]');
    if (variant && link) {
      const url = new URL(this.dataset.url, location.origin);
      url.searchParams.set('variant', variant.id);
      const option = variant.title === 'Default Title' ? '' : ' — ' + variant.title;
      link.href = 'https://wa.me/96170164337?text=' + encodeURIComponent(this.dataset.prefix + ' ' + this.dataset.title + option + ' ' + url.href);
    }
    const row = this.querySelector('[data-delivery-row]');
    const note = this.querySelector('[data-delivery-note]');
    if (variant && row && note) {
      const quantityInput = this.section.querySelector('.product-details product-form-component input[name="quantity"]');
      const quantity = Math.max(1, parseInt(quantityInput?.value, 10) || 1);
      const fee = variant.ship === false ? undefined : this.deliveryFor(Number(variant.grams) * quantity);
      row.hidden = fee === undefined;
      if (fee !== undefined) row.querySelector('[data-delivery]').textContent = fee ?? row.dataset.over;
      note.textContent = fee === undefined ? note.dataset.fallback : note.dataset.weight;
    }
  }
}
if (!customElements.get('ps-purchase-assist')) customElements.define('ps-purchase-assist', PsPurchaseAssist);
  } catch(e) { console.error(e); }
})();

})();
